export default __webpack_public_path__ + "static/media/laptop_stand.3effca77.jpg";